import React, { useEffect, useState } from 'react';
import { Carousel, Tag, Card, Avatar ,Modal, Tabs} from 'antd';
import "./DynamicCarousel.css";
// import 'antd/dist/antd.css'; // Import Ant Design styles
// React component for the tabbed table
const { TabPane } = Tabs;



const DynamicCarousel = ({ title, content }) => {
    useEffect(() => {
        console.log("HERE TITLE IS: ", title);
    }, [title]);

    // Random colors for avatars
    const randomColors = [
        '#f56a00', '#1890ff', '#52c41a', '#eb2f96', '#faad14', '#722ed1', '#13c2c2', '#fa541c'
    ];

    const getRandomColor = () => {
        return randomColors[Math.floor(Math.random() * randomColors.length)];
    };

    const centralAvatarSize = 150; // Central avatar size
    const peripheralAvatarSize = 100; // Peripheral avatar size
    const radius = 200; // Reduced radius for the arrows
    const centerX = 300; // Central X position
    const centerY = 300; // Central Y position
    const arrowOffset = 30; // Distance between arrowhead and peripheral avatars

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState('');



    const handleAvatarClick = (item) => {
        // Actualizează titlul și conținutul modalei
        setModalTitle(item.textToDisplay);
        setModalContent(
            item.textToDisplay === "Stimulus"
                ? (
                    <>
                        <p><b>1. In Psychology and Biology:</b> A stimulus refers to an external event or change that provokes a response
                            from an organism. The reaction is the organism’s response to the stimulus.</p>
                        <p><b>Example:</b> In classical conditioning, a stimulus like a bell ringing can cause a reaction (salivation
                            in Pavlov's famous experiment) if paired with food. The bell alone is the stimulus, and the salivation
                            is the reaction.</p>
                        <p style={{ fontSize: 64 }}> 🐶🔔🤤</p>
                        <p><b>2. In Programming (e.g., React):</b> In the context of React (a JavaScript library for building user
                            interfaces), the verb "to react" describes the behavior of the UI in response to stimuli, such as user
                            interactions or data updates.</p>
                        <p><b>Stimulus:</b> The user performs an action (clicks a button, submits a form, etc.), or data changes
                            (e.g., new data is fetched from an API).</p>
                        <p><b>Reaction:</b> The UI responds by re-rendering based on the updated state or props.</p>
                        <p style={{ fontSize: 64 }}>🫸🏼🔴📺</p>
                    </>
                )
                : item.textToDisplay === "Reaction" ? (
                        <>
                            <p><b>1. In Psychology and Biology:</b> A reaction is the behavior or response of an organism triggered by a stimulus.
                                While the stimulus initiates the process, the reaction is the result of processing and responding to that stimulus.</p>
                            <p><b>Example:</b> In Pavlov's experiment, the dog's salivation is the reaction to the bell ringing, once the connection
                                between the bell and food has been established.</p>
                            <p style={{ fontSize: 64 }}> 🐶🔔🤤</p>
                            <p><b>2. In Programming (e.g., React):</b> A reaction in React occurs when the system re-renders components to reflect
                                changes in state or props. This ensures the UI remains synchronized with the underlying data.</p>
                            <p><b>Key Difference:</b> While the stimulus is the trigger (e.g., a user clicking a button), the reaction is the visible
                                outcome in the UI (e.g., showing a new page or updating a list).</p>
                            <p style={{ fontSize: 64 }}>🫸🏼🔄📱</p>
                        </>
                    )

                    : item.textToDisplay === "Reflex" ? (
                            <>
                                <p><b>1. In Psychology and Biology:</b> A reflex is an automatic and involuntary response to a stimulus. Reflexes are often rapid
                                    and occur without conscious thought, ensuring immediate reaction to potential dangers or environmental changes.</p>
                                <p><b>Example:</b> The knee-jerk response when a doctor taps your knee with a reflex hammer is a classic example of a reflex.</p>
                                <p style={{ fontSize: 64 }}>🦵🔨↗️</p>
                                <p><b>2. In Programming:</b> Although "reflex" is not a standard programming term, it can be thought of as analogous to predefined
                                    behaviors in systems or libraries that automatically execute without developer intervention.</p>
                                <p><b>Example:</b> Default error handling in many systems or automatic retries in API requests can be likened to a "programmatic reflex."</p>
                                <p style={{ fontSize: 64 }}>💻🤖💡</p>
                            </>
                        )
                        : item.textToDisplay === "Response" ? (
                                <>
                                    <p><b>1. In Psychology and Biology:</b> A response is a broader term encompassing any reaction to a stimulus, whether reflexive or
                                        deliberate. It includes both automatic (reflexes) and conscious behaviors.</p>
                                    <p><b>Example:</b> Moving your hand away from a hot stove is a reflexive response, while deciding to wear a coat because it's cold is a
                                        deliberate response.</p>
                                    <p style={{ fontSize: 64 }}>🔥✋➡️</p>
                                    <p><b>2. In Programming:</b> A response often refers to the output or feedback given by a system or server after receiving a request.</p>
                                    <p><b>Example:</b> A REST API returning a JSON object after a GET request is an example of a response in programming.</p>
                                    <p style={{ fontSize: 64 }}>🌐➡️📄</p>
                                </>
                            )
                            : item.textToDisplay === "Adaptation" ? (
                                    <>
                                        <p><b>1. In Psychology and Biology:</b> Adaptation is the process through which an organism adjusts to changes in its environment
                                            to improve its survival and reproduction chances.</p>
                                        <p><b>Example:</b> Over time, animals living in colder climates develop thicker fur to adapt to the harsh conditions.</p>
                                        <p style={{ fontSize: 64 }}>🐻❄️⬆️</p>
                                        <p><b>2. In Programming:</b> Adaptation refers to making changes or updates to systems, algorithms, or code to improve functionality,
                                            efficiency, or compatibility with new environments.</p>
                                        <p><b>Example:</b> Refactoring legacy code to work with modern APIs or frameworks is a form of adaptation.</p>
                                        <p style={{ fontSize: 64 }}>🔧➡️📈</p>
                                    </>
                                )
                : <p>Content for {item.textToDisplay} is TBD...</p>
        );
        setIsModalOpen(true);
    };

    const renderTable = (content) => (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
            <tr>
                <th style={{ padding: '12px', textAlign: 'left', border: '1px solid #ddd' }}>Concept</th>
                <th style={{ padding: '12px', textAlign: 'left', border: '1px solid #ddd' }}>Description</th>
                <th style={{ padding: '12px', textAlign: 'left', border: '1px solid #ddd' }}>Useful Links</th>
            </tr>
            </thead>
            <tbody>
            {content.map((concept, index) => (
                <tr key={index}>
                    <td style={{ padding: '12px', border: '1px solid #ddd' }}>{concept.concept}</td>
                    <td style={{ padding: '12px', border: '1px solid #ddd' }}>{concept.description}</td>
                    <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                        <a href={concept.link} target="_blank" rel="noopener noreferrer">Learn More</a>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );



    const handleModalClose = () => setIsModalOpen(false);


    return (
        <div>
            {/* Glowy Tag for the title */}
            <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                <Tag
                    style={{
                        fontSize: '25px',
                        padding: '10px 20px',
                        background: '#ffddac',
                        color: '#4c394b',
                        borderColor: '#ffddac',
                        borderRadius: '20px',
                        textShadow: '0 0 8px rgba(255, 255, 255, 0.8)',
                        boxShadow: '0 0 15px rgba(0, 21, 41, 0.8)',
                        width: '350px',
                        fontFamily: 'bold',
                        alignItems: 'center',
                    }}
                >
                    {title}
                </Tag>
            </div>

            {/* Content based on title */}
            {title === "History of React" ? (
                <Carousel autoplay style={{background: "transparent"}} dotPosition={"bottom"}
                          dots={{className: 'custom-dots'}}>
                    {content.map((item, index) => (
                        <div
                            key={index}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '20px',
                                height: '100%',
                            }}
                        >
                            <Card
                                hoverable
                                style={{
                                    width: '50%',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                    marginLeft: '380px',
                                    backgroundColor: "#ffddac",
                                }}
                                cover={
                                    item.imageSrc && (
                                        <img
                                            alt="example"
                                            src={item.imageSrc}
                                            style={{
                                                width: '100%',
                                                height: '350px',
                                                borderRadius: '10px',
                                            }}
                                        />
                                    )
                                }
                            >
                                <Card.Meta
                                    description={item.textToDisplay}
                                    style={{
                                        fontSize: "20px",
                                        fontFamily: "fantasy",
                                        font: "bold",
                                        color: "#000000",
                                    }}
                                />
                            </Card>
                        </div>
                    ))}
                </Carousel>
            ) : title === "Glossary of Related Terms" ? (
                <div style={{position: 'relative', width: '100%', height: '600px'}}>
                    {/* SVG for arrows */}
                    <svg
                        width="100%"
                        height="600px"
                        style={{position: 'absolute', top: 0, left: 0}}
                    >
                        <defs>
                            <marker
                                id="arrowhead"
                                markerWidth="10"
                                markerHeight="7"
                                refX="10"
                                refY="3.5"
                                orient="auto"
                                markerUnits="strokeWidth"
                            >
                                <polygon points="0 0, 10 3.5, 0 7" fill="#999"/>
                            </marker>
                        </defs>

                        {content.map((item, idx) => {
                            const angle = (idx / content.length) * 2 * Math.PI; // Distribuie avatarele pe cerc
                            const avatarX = centerX + (radius - arrowOffset) * Math.cos(angle); // Poziția X a avatarului
                            const avatarY = centerY + (radius - arrowOffset) * Math.sin(angle); // Poziția Y a avatarului
                            const arrowX = centerX + radius * Math.cos(angle); // Capătul săgeții
                            const arrowY = centerY + radius * Math.sin(angle); // Capătul săgeții

                            return (
                                <>
                                    <line
                                        key={`arrow-${idx}`}
                                        x1={centerX}
                                        y1={centerY}
                                        x2={arrowX}
                                        y2={arrowY}
                                        stroke="#999"
                                        strokeWidth="2"
                                        markerEnd="url(#arrowhead)"
                                    />
                                    <circle
                                        cx={arrowX}
                                        cy={arrowY}
                                        r="3"
                                        fill="#999"
                                    />
                                </>
                            );
                        })}
                    </svg>

                    {/* Central Avatar */}
                    <Avatar
                        size={centralAvatarSize}
                        style={{
                            backgroundColor: '#1890ff',
                            fontSize: '24px',
                            fontWeight: 'bold',
                            color: '#fff',
                            position: 'absolute',
                            top: `calc(${centerY}px - ${centralAvatarSize / 2}px)`,
                            left: `calc(${centerX}px - ${centralAvatarSize / 2}px)`,
                        }}
                    >
                        REACT
                    </Avatar>

                    {/* Peripheral Avatars */}
                    {content.map((item, idx) => {
                        const angle = (idx / content.length) * 2 * Math.PI; // Distribuie avatarele pe cerc
                        const avatarX = centerX + (radius - arrowOffset) * Math.cos(angle); // Poziția X a avatarului
                        const avatarY = centerY + (radius - arrowOffset) * Math.sin(angle); // Poziția Y a avatarului

                        return (
                            <>
                                <Avatar
                                    key={idx}
                                    size={peripheralAvatarSize}
                                    //
                                    onClick={() => handleAvatarClick(item)}
                                    style={{
                                        backgroundColor: getRandomColor(),
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        color: '#fff',
                                        position: 'absolute',
                                        top: `calc(${avatarY}px - ${peripheralAvatarSize / 2}px)`,
                                        left: `calc(${avatarX}px - ${peripheralAvatarSize / 2}px)`,
                                    }}
                                >
                                    <span style={{fontStyle: 'italic', fontWeight: 'bold'}}>{item.textToDisplay}</span>
                                </Avatar>

                                <Modal title={modalTitle}
                                       open={isModalOpen}
                                       onOk={handleModalClose}
                                       onCancel={handleModalClose}>

                                    {modalContent}
                                </Modal>


                            </>
                        );
                    })}
                </div>
            ) : title === "To REACT in different domains" ? (
                    <Carousel autoplay style={{background: "transparent"}} dotPosition={"bottom"}
                              dots={{className: 'custom-dots'}}>
                        {content.map((item, index) => (
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: '20px',
                                    height: '100%',
                                }}
                            >
                                <Card
                                    hoverable
                                    style={{
                                        width: '50%',
                                        borderRadius: '10px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        flexDirection: 'column-reverse',
                                        marginLeft: '380px',
                                        backgroundColor: "#ffddac",
                                    }}
                                    cover={
                                        item.imageSrc && (
                                            <img
                                                alt="example"
                                                src={item.imageSrc}
                                                style={{
                                                    width: '100%',
                                                    height: '350px',
                                                    borderRadius: '10px',
                                                }}
                                            />
                                        )
                                    }
                                >

                                    <Card.Meta
                                        description={item.textToDisplay}
                                        style={{
                                            fontSize: "20px",
                                            fontFamily: "Fantasy",
                                            font: "bold",
                                            color: "#000000",
                                        }}
                                    />
                                </Card>
                            </div>
                        ))}
                    </Carousel>
                )
                : title === "React Framework Glossary" ? (

                        <div>


                            {/* Ant Design Tabs */}
                            <Tabs defaultActiveKey="1" centered style={{backgroundColor: "#FFDDAC", border: 10,borderColor: "#2A1C33"}}>
                                <TabPane tab="React Concepts" key="1">
                                    {renderTable(content.reactConcepts)}
                                </TabPane>
                                <TabPane tab="Advanced React Concepts" key="2">
                                    {renderTable(content.advancedReactConcepts)}
                                </TabPane>
                            </Tabs>
                        </div>

                    )
                : title === "Human Reactions In Culture" ? (
                            <div>
                                {/* Ant Design Tabs */}
                                <Tabs defaultActiveKey="1" centered style={{backgroundColor: "#FFDDAC", border: 10,borderColor: "#2A1C33"}}>
                                    <TabPane tab="ART 🖼️" key="1">
                                        <Carousel autoplay style={{ background: "transparent" }} dotPosition={"bottom"} dots={{ className: 'custom-dots' }}>
                                            {content.art.map((item, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        padding: '20px',
                                                        height: '100%',
                                                    }}
                                                >
                                                    {/* Container principal pentru imagine și text */}
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row', // Orientare pe linie
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            width: '80%', // Lățimea containerului
                                                            backgroundColor: "#ffddac",
                                                            borderRadius: '10px',
                                                            padding: '10px',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Shadow similar cu hoverable
                                                        }}
                                                    >
                                                        {/* Imaginea */}
                                                        {item.imageSrc && (
                                                            <div
                                                                style={{
                                                                    flex: '1', // Ocupă 50% din spațiu
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <img
                                                                    alt="example"
                                                                    src={item.imageSrc}
                                                                    style={{
                                                                        width: '80%', // Imaginea ocupă 80% din lățime
                                                                        height: '350px', // Înălțimea imaginii
                                                                        borderRadius: '10px',
                                                                        objectFit: 'cover',
                                                                    }}
                                                                />
                                                            </div>
                                                        )}

                                                        {/* Textul */}
                                                        <div
                                                            style={{
                                                                flex: '1', // Ocupă restul spațiului
                                                                padding: '20px', // Spațiu în jurul textului
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                justifyContent: 'center',
                                                            }}
                                                        >
                                                            <p style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '10px' }}>
                                                                <strong>Name:</strong> {item.name}
                                                            </p>
                                                            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
                                                                <strong>Reaction:</strong> {item.reaction}
                                                            </p>
                                                            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
                                                                <strong>Details:</strong> {item.details}
                                                            </p>
                                                            <p style={{ fontSize: '18px', marginBottom: '0' }}>
                                                                <strong>Fun fact:</strong> {item.funFact}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Carousel>
                                    </TabPane>
                                    <TabPane tab="FILMOGRAPHY 🎥" key="2">
                                        <Carousel autoplay style={{ background: "transparent" }} dotPosition={"bottom"} dots={{ className: 'custom-dots' }}>
                                            {content.filmography.map((item, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        padding: '20px',
                                                        height: '100%',
                                                    }}
                                                >
                                                    {/* Container principal pentru imagine și text */}
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row', // Orientare pe linie
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            width: '80%', // Lățimea containerului
                                                            backgroundColor: "#ffddac",
                                                            borderRadius: '10px',
                                                            padding: '10px',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Shadow similar cu hoverable
                                                        }}
                                                    >
                                                        {/* Imaginea */}
                                                        {item.imageSrc && (
                                                            <div
                                                                style={{
                                                                    flex: '1', // Ocupă 50% din spațiu
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <img
                                                                    alt="example"
                                                                    src={item.imageSrc}
                                                                    style={{
                                                                        width: '80%', // Imaginea ocupă 80% din lățime
                                                                        height: '500px', // Înălțimea imaginii
                                                                        borderRadius: '10px',
                                                                        objectFit: 'cover',
                                                                    }}
                                                                />
                                                            </div>
                                                        )}

                                                        {/* Textul */}
                                                        <div
                                                            style={{
                                                                flex: '1', // Ocupă restul spațiului
                                                                padding: '20px', // Spațiu în jurul textului
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                justifyContent: 'center',
                                                            }}
                                                        >
                                                            <p style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '10px' }}>
                                                                <strong>Name:</strong> {item.name}
                                                            </p>
                                                            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
                                                                <strong>Reaction:</strong> {item.reaction}
                                                            </p>
                                                            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
                                                                <strong>Details:</strong> {item.details}
                                                            </p>
                                                            <p style={{ fontSize: '18px', marginBottom: '0' }}>
                                                                <strong>Fun fact:</strong> {item.funFact}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Carousel>

                                    </TabPane>
                                    <TabPane tab="LITERATURE 📚" key="3">
                                        <Carousel autoplay style={{ background: "transparent" }} dotPosition={"bottom"} dots={{ className: 'custom-dots' }}>
                                            {content.literature.map((item, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        padding: '20px',
                                                        height: '100%',
                                                    }}
                                                >
                                                    {/* Container principal pentru imagine și text */}
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row', // Orientare pe linie
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            width: '80%', // Lățimea containerului
                                                            backgroundColor: "#ffddac",
                                                            borderRadius: '10px',
                                                            padding: '10px',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Shadow similar cu hoverable
                                                        }}
                                                    >
                                                        {/* Imaginea */}
                                                        {item.imageSrc && (
                                                            <div
                                                                style={{
                                                                    flex: '1', // Ocupă 50% din spațiu
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <img
                                                                    alt="example"
                                                                    src={item.imageSrc}
                                                                    style={{
                                                                        width: '80%', // Imaginea ocupă 80% din lățime
                                                                        height: '500px', // Înălțimea imaginii
                                                                        borderRadius: '10px',
                                                                        // objectFit: 'cover',
                                                                    }}
                                                                />
                                                            </div>
                                                        )}

                                                        {/* Textul */}
                                                        <div
                                                            style={{
                                                                flex: '1', // Ocupă restul spațiului
                                                                padding: '20px', // Spațiu în jurul textului
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                justifyContent: 'center',
                                                            }}
                                                        >
                                                            <p style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '10px' }}>
                                                                <strong>Name:</strong> {item.name}
                                                            </p>
                                                            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
                                                                <strong>Reaction:</strong> {item.reaction}
                                                            </p>
                                                            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
                                                                <strong>Details:</strong> {item.details}
                                                            </p>
                                                            <p style={{ fontSize: '18px', marginBottom: '0' }}>
                                                                <strong>Fun fact:</strong> {item.funFact}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Carousel>
                                    </TabPane>
                                    <TabPane tab="THEATRE 🎭" key="4">
                                        <Carousel autoplay style={{ background: "transparent" }} dotPosition={"bottom"} dots={{ className: 'custom-dots' }}>
                                            {content.theatre.map((item, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        padding: '20px',
                                                        height: '100%',
                                                    }}
                                                >
                                                    {/* Container principal pentru imagine și text */}
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row', // Orientare pe linie
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            width: '80%', // Lățimea containerului
                                                            backgroundColor: "#ffddac",
                                                            borderRadius: '10px',
                                                            padding: '10px',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Shadow similar cu hoverable
                                                        }}
                                                    >
                                                        {/* Imaginea */}
                                                        {item.imageSrc && (
                                                            <div
                                                                style={{
                                                                    flex: '1', // Ocupă 50% din spațiu
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <img
                                                                    alt="example"
                                                                    src={item.imageSrc}
                                                                    style={{
                                                                        width: '100%', // Imaginea ocupă 80% din lățime
                                                                        height: '500px', // Înălțimea imaginii
                                                                        borderRadius: '10px',
                                                                        // objectFit: 'cover',
                                                                    }}
                                                                />
                                                            </div>
                                                        )}

                                                        {/* Textul */}
                                                        <div
                                                            style={{
                                                                flex: '1', // Ocupă restul spațiului
                                                                padding: '20px', // Spațiu în jurul textului
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                justifyContent: 'center',
                                                            }}
                                                        >
                                                            <p style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '10px' }}>
                                                                <strong>Name:</strong> {item.name}
                                                            </p>
                                                            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
                                                                <strong>Reaction:</strong> {item.reaction}
                                                            </p>
                                                            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
                                                                <strong>Details:</strong> {item.details}
                                                            </p>
                                                            <p style={{ fontSize: '18px', marginBottom: '0' }}>
                                                                <strong>Fun fact:</strong> {item.funFact}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Carousel>
                                    </TabPane>
                                    <TabPane tab="SYMBOLS ☣️" key="5">
                                        <Carousel autoplay style={{background: "transparent"}} dotPosition={"bottom"}
                                                  dots={{className: 'custom-dots'}}>
                                            {content.symbols.map((item, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        padding: '20px',
                                                        height: '100%',
                                                    }}
                                                >
                                                    <Card
                                                        hoverable
                                                        style={{
                                                            width: '50%',
                                                            borderRadius: '10px',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            flexDirection: 'column-reverse',
                                                            marginLeft: '380px',
                                                            backgroundColor: "#ffddac",
                                                        }}
                                                        cover={
                                                            item.imageSrc && (
                                                                <img
                                                                    alt="example"
                                                                    src={item.imageSrc}
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '350px',
                                                                        borderRadius: '10px',
                                                                    }}
                                                                />
                                                            )
                                                        }
                                                    >

                                                        <Card.Meta
                                                            description={ <>
                                                                <p><strong>Name:</strong> {item.name}</p>
                                                                <p><strong>Reaction:</strong> {item.reaction}</p>
                                                                <p><strong>Details:</strong> {item.details}</p>
                                                                <p><strong>Fun fact:</strong> {item.funFact}</p>
                                                            </>}
                                                            style={{
                                                                fontSize: "20px",
                                                                fontFamily: "Fantasy",
                                                                font: "bold",
                                                                color: "#000000",
                                                            }}
                                                        />
                                                    </Card>
                                                </div>
                                            ))}
                                        </Carousel>
                                    </TabPane>
                                </Tabs>
                            </div>
                        )
                : <p>TBD...</p>
            }
        </div>
    );
};

export default DynamicCarousel;


